import script from "./CouponUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponUserForm.vue?vue&type=script&setup=true&lang=js"

import "./CouponUserForm.vue?vue&type=style&index=0&id=62e190b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62e190b5"]])

export default __exports__